module.exports = __webpack_public_path__ + "img/rentini-landing-banner.72aa473e.gif";